import request from "@/utils/request";

// 分页查询
export function queryDefinition(params) {
  return request({
    url: "/process/definition/page",
    method: "post",
    params,
  });
}

// 激活 or 挂起
export function changeStatus(definitionId) {
  return request({
    url: `/process/definition/changeStatus/${definitionId}`,
    method: "get",
  });
}

// 删除
export function deleteDefinition(definitionId) {
  return request({
    url: `/process/definition/deleteDefinition/${definitionId}`,
    method: "get",
  });
}
